/**
 * @author Rajesh Bodapati
 * @email rajesh.bodapati@ul.com
 * @create date 2021-05-24 14:19:50
 * @modify date 2021-05-24 14:19:50
 * @desc [description]
 */
<template>
<div class="col-md-12 col-lg-12 col-sm-12 pl-0 xs-pr-0">
    <div class="first_table">
      <table class="table activity-tracker-table">
        <thead>
          <tr>
            <th class="filter-th wd-65"></th>
            <th class="wd-20">Name</th>
            <th class="wd-25">Description</th>
            <th class>Active</th>
            <th class="wd-18">AccountType</th>
            <th class>Permission</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(rowVal, index) in rolesList"
            :key="index"
            :class="{ 'on-hover':evenHover[index]}"
            @mouseover="mouseOver(index)"
            @mouseleave="mouseOut(index)"
          >
            <td class="menu-td">
              <div
                :id="'trackerActionDots'+index"
                class="dropdown dropdown-export export-activity-menu"
              >
                <div data-toggle="dropdown" @click="menuDropdown" style="margin-top:1px;">
                  <span class="dropdown-toggle">
                    <i class="fa fa-ellipsis-v menu-dots cursor-pointer"></i>
                  </span>
                </div>
                <ul
                  class="activitytrackermenu dropdown-menu export-menu"
                  v-bind:class="changeClass  ?  'addReverse':''"
                >
                  <li @click="updateActiveStatus(rowVal)">
                    <a v-if="rowVal.is_active">
                      <img
                        src="/static/images/icons/delete_icon.svg"
                        class="tracker-images"
                        alt="delete-icon"
                      />
                      <span class="text-color-delete-red menu-dots-links">Deactive Role</span>
                    </a>
                    <a v-else>
                      <img
                        src="/static/images/icons/check.svg"
                        class="tracker-images"
                        alt="check-icon"
                      />
                      <span class="text-color-blue">Activate Role</span>
                    </a>
                  </li>
                  <li class="divider"></li>
                  <li @click="EditService(rowVal)">
                    <a class="text-color-delete-red menu-dots-links">
                      <img src="/static/images/icons/update_service.svg" class="tracker-images" alt="update-icon"/>
                      <span class="text-color-blue">Update Services</span>
                    </a>
                  </li>
                  <li class="divider"></li>
                  <li @click="ExportRole(rowVal)">
                    <a class="text-color-delete-red menu-dots-links">
                      <img src="/static/images/icons/share_icon.svg" class="tracker-images" alt="share-icon"/>
                      <span class="text-color-blue">Export Role</span>
                    </a>
                  </li>
                  <li class="divider"></li>
                  <li @click="importFile(rowVal)">
                    <a class="text-color-delete-red menu-dots-links">
                      <img src="/static/images/icons/profile_icon.svg" class="tracker-images" alt="profile-icon"/>
                      <span class="text-color-blue">Import Role</span>
                    </a>
                  </li>
                </ul>
              </div>
            </td>
            <td class="dropdown-column"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="data_table shadow_col">
      <table class="table dataList table-responsive activity-tracker-table">
        <thead>
          <tr class="shadow_col">
            <th class="wd-20">Name</th>
            <th class="wd-25">Description</th>
            <th class>Active</th>
            <th class="wd-18">AccountType</th>
            <th class>Permission</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(rowVal, index) in rolesList"
            :key="index"
            :class="{ 'on-hover':evenHover[index]}"
            @mouseover="mouseOver(index)"
            @mouseleave="mouseOut(index)"
          >
            <td class="wd-20">
              <base-tooltip :content="rowVal.role_name">
                {{rowVal.role_name.substring(0,10)}}
              </base-tooltip>
            </td>
            <td class="wd-25">
              <base-tooltip :content="rowVal.description">
                {{rowVal.description.substring(0,19)}}
              </base-tooltip>
            </td>
            <td class>
              <img v-if="rowVal.is_active" src="/static/images/icons/check.svg" class="tracker-images center" alt="check-icon"/>
            </td>
            <td class="wd-18">
              <base-tooltip v-if="rowVal.accountTypeDesc" :content="rowVal.accountTypeDesc">
                {{rowVal.accountTypeDesc.length > 3 ? rowVal.accountTypeDesc.substring(0,10) : rowVal.accountTypeDesc}}
              </base-tooltip>
            </td>
            <td class>
              <a class="cursor-pointer" @click="viewRBACTemplate(rowVal)">
                <img src="/static/images/icons/eye.svg" class="tracker-images" alt="eye-icon"/>
                <span>View</span>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="rolesList.length===0" class="norecords_wrapper">
      <div class="no-records-found">No Roles Found</div>
    </div>
    <rbac-services-modal :roleDetails="roleDetails" :selectedRoleId="selectedRoleId" :selectedRoleName="selectedRoleName" :selectedRoleServices="selectedRoleServices" />
    <rbac-view-services-modal :selectedRoleName="selectedRoleName" :selectedRoleServices="selectedRoleServices" />
    <rbac-active-status-modal :roleDetails="roleDetails" @updateRoleActiveStatus="getListOfRoles" />
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import $ from 'jquery';
import FileSaver from 'file-saver';
import Loader from '../UIComponents/Loader.vue';
import EventBus from '../../utils/event-bus';
import RBACServicesModal from './RBACServicesModal.vue';
import RBACViewServicesModal from './RBACViewServicesModal.vue';
import RBACActiveStatusModal from './RBACActiveStatusModal.vue';
import { getListOfRoles, getListOfAccountTypes } from '../../apis/rbac';
import BaseTooltip from '../Common/BaseTooltip.vue';

export default {
  components: {
    Loader,
    'rbac-services-modal': RBACServicesModal,
    'rbac-view-services-modal': RBACViewServicesModal,
    'rbac-active-status-modal': RBACActiveStatusModal,
    BaseTooltip,
  },
  props: [],
  data() {
    return {
      accountTypeList: [],
      type: '',
      roleDetails: '',
      loaderStatus: false,
      rolesList: [],
      evenHover: [],
      changeClass: false,
      selectedRoleServices: [],
      selectedRoleName: '',
      selectedRoleId: '',
    };
  },
  methods: {
    async getListOfAccountTypes() {
      this.accountTypeList = await getListOfAccountTypes();
    },
    importFile(role) {
      this.selectedRoleId = role.role_id;
      this.$emit('uploadType', 'existing_role_template', this.selectedRoleId);
    },
    ExportRole(role) {
      const blob = new Blob([JSON.stringify(role, null, 2)], { type: 'application/json' });
      FileSaver.saveAs(blob, `${role.role_name}.json`);
    },
    async getListOfRoles() {
      this.loaderStatus = true;
      const response = await getListOfRoles();
      response.forEach((role, index) => {
        role.account_type.forEach((accountTypeId) => { // Account type desc
          const selectedAccountType = this.accountTypeList.find((accountType) => accountType.account_type_id === accountTypeId);
          if (!response[index].accountTypeDesc) {
            response[index].accountTypeDesc = selectedAccountType.account_type;
          } else {
            response[index].accountTypeDesc += `, ${selectedAccountType.account_type}`;
          }
        });
      });
      this.rolesList = response;
      this.loaderStatus = false;
    },
    EditService(role) {
      this.roleDetails = role;
      this.selectedRoleId = role.role_id;
      this.selectedRoleName = role.role_name;
      this.selectedRoleServices = role.services;
      $('#rbacServicesModal').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    viewRBACTemplate(role) {
      this.selectedRoleServices = role.services;
      this.selectedRoleName = role.role_name;
      $('#rbacViewServicesModal').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    updateActiveStatus(role) {
      this.roleDetails = role;
      this.selectedRoleId = role.role_id;
      this.selectedRoleName = role.role_name;
      $('#rbacActiveStatusModal').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    mouseOver(index) {
      this.$set(this.evenHover, index, true);
    },
    mouseOut(index) {
      this.$set(this.evenHover, index, false);
    },
    menuDropdown(event) {
      $('td.sticky').css('z-index', 0);
      $(event.target).closest('td.sticky').css('z-index', 1);
      this.dropDownMenuDisable = true;
      this.changeClass = false;
      if (event.screenY > window.innerHeight - 90) {
        this.changeClass = true;
      } else {
        this.changeClass = false;
      }
    },
  },
  mounted() {
    EventBus.$on('updateRoleList', () => {
      setTimeout(this.getListOfRoles(), 1000);
    });
  },
  beforeDestroy() {
    EventBus.$off('updateRoleList');
  },
  async created() {
    this.loaderStatus = true;
    await this.getListOfAccountTypes();
    await this.getListOfRoles();
  },
};
</script>
<style scoped lang="scss">
$background-color_light_blue: rgba(103, 177, 226, 0.35);
$font-family-Roboto: Roboto;
$font-style-normal: normal;
.table{
  border-top: 1px solid $gray74;
}
@media screen and (max-width: 767px){
  .xs-hide{
    display: hidden;
  }
  .first_table {
    >.table {
      width: 898px;
      max-width: unset;
    }
  }
  .first_table{
    overflow-x: hidden;
    width: 100%;
  }
  .data_table{
    overflow-x: auto;
    width: calc(100% - 75px);
  }
  .shadow_col{
    box-shadow: 4px 0px 4px rgba(0, 0, 0, 0.1) inset;
  }

  .activity-tracker-table.table {
    >thead {
      &:first-child {
        >tr {
          &:first-child {
            >th {
              padding-left: 8px;
            }
          }
        }
      }
    }
  }

  .activity-tracker-table.table {
    >tbody {
      >tr {
        >td {
          &:first-child {
            padding-left: 8px !important;
          }
        }
      }
    }
  }
}
.xs-hide{
  display: hidden;
}
.wd-65{
  width: 65px;
}
 .width_16{
  width: 16.6%;
}
.first_table{
  position: relative;
}
.spinnerTop {
	z-index: 3 !important;
}
.data_table{
  background: $white;
  position: absolute;
  top: 0;
  left: 75px;
  z-index: 2;
  padding-right: 15px;
}
.table_first{
  width: 130px;
  vertical-align: top;
}
.activity-tracker-table{
  table-layout: fixed;
}
.activitytrackermenu.export-menu {
	&:after {
		left: 30px !important;
		visibility: visible;
		box-shadow: none;
		border-top: 1px solid $light-grey-alpha;
		border-left: 1px solid $light-grey-alpha;
	}
}
.center {
  text-align: center;
  width: 50%;
}
.fa.menu-dots {
  font-size: $font-22;
}
th.checkbox-cell {
	height: 45px;
}
.activity-tracker-table.table {
	>thead {
		&:first-child {
			>tr {
				&:first-child {
					>th {
						color: $primary;
						font-size: $font-16;
					}
				}
			}
		}
	}
}
.table_first {
	>.table {
		>thead {
			tr {
				th {
					&:first-child {
            width: 70px;
					}
				}
			}
		}
		>tbody {
			tr {
				td {
					&:first-child {
            width: 70px;
					}
				}
			}
		}
	}
}
.activity-tracker-table.table {
	>thead {
		tr {
			th {
				height: 46px;
			}
		}
	}
}
.activity-tracker-table.table {
	>tbody {
		tr {
			td {
				height: 44px;
			}
		}
	}
}
.activity-tracker-table.table {
	thead {
		background-color: $white;
	}
}
.menu-td {
  text-align: right;
}
.activity-tracker-table.table {
	>tbody {
		>tr {
			&:nth-child(even) {
				background-color: $background-color_light_blue;
				border-top: 0.5px solid $gray74;
				border-bottom: 0.5px solid $gray74;
			}
		}
	}
}
.activity-tracker-table.table {
	>tbody {
		>tr {
			&:nth-child(even).on-hover {
				background-color: $background-color_light_blue;
			}
		}
	}
}
tbody {
	>tr.on-hover {
		background-color: $background-color_light_blue;
	}
}
.activity-tracker-table.table {
	>thead {
		>tr {
			>th {
        font-family: $font-family-Roboto;
				font-style: $font-style-normal;
        @include fontItems($font-14, 16px, $font-weight-medium !important);
				color: $primary;
				border-bottom: 0.5px dashed $gray74;
				vertical-align: middle;
				padding: 10px 10px 10px 3px;
			}
		}
	}
}
.activity-tracker-table.table {
	>tbody {
		>tr {
			>td {
				font-family: $font-family-Roboto;
				font-style: $font-style-normal;
        @include fontItems($font-14, 16px, $font-weight-normal);
				color: $dark-black-alpha;
				padding: 10px 10px 10px 3px !important;
			}
		}
	}
}
.checkmark {
  position: relative;
  display: inline-block;
	margin: 3px 0px -4px -7px;
	background-color: $white;
}
.dropdown-column {
  width: 45px;
  text-align: right;
	padding-right: 10px !important;
}
.activitytrackermenu.dropdown-menu.pull-left {
	right: 0px;
	left: auto;
	top: 25px;
	min-width: 200px;
}
ul.activitytrackermenu.dropdown-menu.pull-left {
	li {
		padding-left: 10px;
		padding-bottom: 5px;
	}
}
.dropdown.angle.open {
	&::before {
    display: unset;
    position: absolute;
		pointer-events: none;
		content: "";
		visibility: visible;
		transform: rotate(45deg);
    width: 0.6em;
		height: 0.6em;
		background: $white;
		z-index: 9999;
		right: 10px;
		top: 24px;
		box-shadow: -1px -1px 1px 1px rgba(41, 38, 38, 0.15);
		-webkit-transition: all 0.5s ease-in 0s;
		transition: all 0.5s ease-in 0s;
	}
}
@media only screen and (max-width: 767px) {
  .xs-pr-0 {
    padding-right: 0px !important;
  }
  .activity-tracker-table.dataList {
    width: 768px;
    max-width: unset;
  }
  .table_first {
    >.table {
      position: relative;
      box-shadow: 4px 0px 4px rgba(0, 0, 0, 0.1);
    }
  }
  .table-wrapper {
    >.table.dataList {
      >thead {
        tr {
          th {
            &:first-child {
              padding-left: 10px !important;
            }
          }
        }
      }
      >tbody {
        tr {
          td {
            &:first-child {
              padding-left: 10px !important;
            }
          }
        }
      }
    }
  }
  .table-wrapper {
    overflow: scroll;
  }
  .main-table{
    table-layout: fixed;
  }
  .activity-tracker-table.table-responsive {
    border: none;
  }
  .table_second{
    overflow: scroll;
  }
  .table_first{
    width: 70px;
  }
}
::v-deep .filter-wrapper {
	.el-tag {
    background-color: transparent;
    border: transparent;
    font-family: $font-family-Roboto;
    @include fontItems($font-14, 16px, $font-weight-medium);
    font-style: $font-style-normal;
    color: $primary;
  }
	.el-collapse-item__arrow {
    margin: 0 14px 0 auto;
  }
}
.wd-20 {
  width: 20%;
}
.wd-25 {
  width: 25%;
}
.wd-18 {
  width: 18%;
}
td > {
	a {
		color: $dark-black-alpha;
	}
}
.addReverse {
	top: auto !important;
	bottom: 100%;
	margin-bottom: initial;
}
.addReverse {
	&:after {
		visibility: hidden !important;
		box-shadow: none;
		bottom: -163px;
		border: none;
		border-bottom: 1px solid $light-grey-alpha;
		border-right: 1px solid $light-grey-alpha;
	}
}
</style>
